<template>
	<MicrioViewer
		v-if="!route.meta.standalone"
		:image-id="activeMicrioId"
		:door-duration="700"
		:pause-between="0"
		:zoom-duration="1000"
		:handoff-hold="200"
		:handoff-duration="350"
		@door-activate="onActivate" />

	<!-- Per-page overlay UI only; the map itself is no longer in here. -->
	<router-view v-slot="{ Component }">
		<transition name="fade" mode="out-in">
			<component :is="Component" />
		</transition>
	</router-view>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import MicrioViewer from '@/components/MicrioViewer.vue'
import { HOME_MICRIO_ID, pageByTitle } from '@/config/pages'

const route = useRoute()
const router = useRouter()

const activeMicrioId = computed(() => route.meta.micrioId ?? HOME_MICRIO_ID)

function onActivate(payload: { title: string }) {
	const page = pageByTitle(payload.title)
	if (!page) {
		console.warn('[door] no page configured for title →', payload.title)
		return
	}
	router.push({ name: page.route })
}
</script>

<style lang="scss">
#app {
	font-family: 'NTR Speciaal', sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: #2c3e50;
}

nav {
	padding: 30px;

	a {
		font-weight: bold;
		color: #2c3e50;

		&.router-link-exact-active {
			color: #42b983;
		}
	}
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 300ms ease;
}

.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}
</style>
